export function injectFontFaces(target: HTMLElement): void {
  const cssChunks: string[] = [];

  try {
    for (const sheet of Array.from(document.styleSheets)) {
      let rules: CSSRuleList | null = null;
      try {
        rules = sheet.cssRules;
      } catch {
        continue;
      }
      if (!rules) continue;
      for (const rule of Array.from(rules)) {
        if (rule instanceof CSSFontFaceRule) {
          cssChunks.push(rule.cssText);
        }
      }
    }
  } catch {}

  if (!cssChunks.length) return;

  const style = document.createElement("style");
  style.setAttribute("data-pdf-fonts", "true");
  style.textContent = cssChunks.join("\n");
  target.appendChild(style);
}

export async function ensureFontsReady(
  families: readonly string[]
): Promise<void> {
  if (typeof document === "undefined") return;
  const fontSet: any = (document as any).fonts;
  if (!fontSet) return;

  const sample = "این یک نمونه است ۱۲۳۴۵۶۷۸۹۰ ABC";
  const jobs: Promise<unknown>[] = [];

  for (const family of families) {
    for (const weight of [300, 400, 500, 600, 700, 800, 900]) {
      for (const size of [12, 16, 24, 32, 48]) {
        jobs.push(
          fontSet
            .load(`${weight} ${size}px "${family}"`, sample)
            .catch(() => {})
        );
      }
    }
  }

  try {
    await Promise.all(jobs);
    await fontSet.ready;
  } catch {}

  await new Promise((r) => setTimeout(r, 200));
}
